{
  "OpenapiAccountCapability_or_OpenapiBankAccount_or_OpenapiBankConnectionsResourceLinkAccountSession_or_OpenapiBankConnectionsResourceLinkedAccount_or_OpenapiCard_or_OpenapiCharge_or_OpenapiChargeWithCharge_or_OpenapiChargeWithPayment_or_OpenapiCoupon_or_OpenapiCreditNote_or_OpenapiCustomer_or_OpenapiCustomerResourceGuestCustomer_or_OpenapiDiscount_or_OpenapiDispute_or_OpenapiEmeraldSearchTransaction_or_OpenapiGelatoBlocklistEntryManage_or_OpenapiGelatoVerificationSession_or_OpenapiInvoice_or_OpenapiInvoiceItem_or_OpenapiIssuingAuthorization_or_OpenapiIssuingCard_or_OpenapiIssuingCardholder_or_OpenapiIssuingTransaction_or_OpenapiManagedComplianceResourceSeller_or_OpenapiOrder_or_OpenapiOrdersV2ResourceOrderSearch_or_OpenapiPaymentIntent_or_OpenapiPaymentLink_or_OpenapiPaymentRecord_or_OpenapiPayout_or_OpenapiPlan_or_OpenapiPlatformConnectionStripeType_or_OpenapiPrice_or_OpenapiProduct_or_OpenapiQuote_or_OpenapiRefund_or_OpenapiRefundWithRefund_or_OpenapiSearchMerchantResourcesV2BillingMeterApi_or_OpenapiSearchMerchantResourcesV2LicenseFeeApi_or_OpenapiSearchMerchantResourcesV2LicensedItemApi_or_OpenapiSearchMerchantResourcesV2MeteredItemApi_or_OpenapiSearchMerchantResourcesV2OutboundPaymentApi_or_OpenapiSearchMerchantResourcesV2PricingPlanApi_or_OpenapiSearchMerchantResourcesV2RateCardApi_or_OpenapiSearchMerchantResourcesV2RecipientApi_or_OpenapiSearchMerchantResourcesV2TransactionApi_or_OpenapiSession_or_OpenapiSetupIntent_or_OpenapiSource_or_OpenapiSubscription_or_OpenapiSupportCenterCoreSupportCase_or_OpenapiTax1099KData_or_OpenapiTaxProductResourceInternalTaxTransaction_or_OpenapiTaxRate_or_OpenapiTaxReportingResourceTax1099Form_or_OpenapiTerminalHardwareOrder_or_OpenapiTerminalLocationLocation_or_OpenapiTerminalReaderReader_or_OpenapiThreeDSecureAuthentication_or_OpenapiTransfer_or_OpenapiTransferRecipient": {
    "account": [
      "OpenapiPlatformConnectionStripeType"
    ],
    "bank_account": [
      "OpenapiBankAccount"
    ],
    "capability": [
      "OpenapiAccountCapability"
    ],
    "card": [
      "OpenapiCard"
    ],
    "charge": [
      "OpenapiCharge",
      "OpenapiChargeWithCharge",
      "OpenapiChargeWithPayment"
    ],
    "checkout.session": [
      "OpenapiSession"
    ],
    "corporate_card.transaction": [
      "OpenapiEmeraldSearchTransaction"
    ],
    "coupon": [
      "OpenapiCoupon"
    ],
    "credit_note": [
      "OpenapiCreditNote"
    ],
    "customer": [
      "OpenapiCustomer"
    ],
    "discount": [
      "OpenapiDiscount"
    ],
    "dispute": [
      "OpenapiDispute"
    ],
    "financial_connections.account": [
      "OpenapiBankConnectionsResourceLinkedAccount"
    ],
    "financial_connections.session": [
      "OpenapiBankConnectionsResourceLinkAccountSession"
    ],
    "global_tax_reporting.seller": [
      "OpenapiManagedComplianceResourceSeller"
    ],
    "guest_customer": [
      "OpenapiCustomerResourceGuestCustomer"
    ],
    "identity.blocklist_entry": [
      "OpenapiGelatoBlocklistEntryManage"
    ],
    "identity.verification_session": [
      "OpenapiGelatoVerificationSession"
    ],
    "invoice": [
      "OpenapiInvoice"
    ],
    "invoiceitem": [
      "OpenapiInvoiceItem"
    ],
    "issuing.authorization": [
      "OpenapiIssuingAuthorization"
    ],
    "issuing.card": [
      "OpenapiIssuingCard"
    ],
    "issuing.cardholder": [
      "OpenapiIssuingCardholder"
    ],
    "issuing.transaction": [
      "OpenapiIssuingTransaction"
    ],
    "order": [
      "OpenapiOrder"
    ],
    "order_v2": [
      "OpenapiOrdersV2ResourceOrderSearch"
    ],
    "payment_intent": [
      "OpenapiPaymentIntent"
    ],
    "payment_link": [
      "OpenapiPaymentLink"
    ],
    "payment_record": [
      "OpenapiPaymentRecord"
    ],
    "payout": [
      "OpenapiPayout"
    ],
    "plan": [
      "OpenapiPlan"
    ],
    "price": [
      "OpenapiPrice"
    ],
    "product": [
      "OpenapiProduct"
    ],
    "quote": [
      "OpenapiQuote"
    ],
    "recipient": [
      "OpenapiTransferRecipient"
    ],
    "refund": [
      "OpenapiRefund",
      "OpenapiRefundWithRefund"
    ],
    "setup_intent": [
      "OpenapiSetupIntent"
    ],
    "source": [
      "OpenapiSource"
    ],
    "subscription": [
      "OpenapiSubscription"
    ],
    "support_case_dashboard_search": [
      "OpenapiSupportCenterCoreSupportCase"
    ],
    "tax_internal.transaction": [
      "OpenapiTaxProductResourceInternalTaxTransaction"
    ],
    "tax_rate": [
      "OpenapiTaxRate"
    ],
    "tax_reporting.tax_1099_form": [
      "OpenapiTaxReportingResourceTax1099Form"
    ],
    "tax_reporting.tax_1099k_data": [
      "OpenapiTax1099KData"
    ],
    "terminal.hardware_order": [
      "OpenapiTerminalHardwareOrder"
    ],
    "terminal.location": [
      "OpenapiTerminalLocationLocation"
    ],
    "terminal.reader": [
      "OpenapiTerminalReaderReader"
    ],
    "three_d_secure.authentication": [
      "OpenapiThreeDSecureAuthentication"
    ],
    "transfer": [
      "OpenapiLegacyTransfer"
    ],
    "v2_billing_meter": [
      "OpenapiSearchMerchantResourcesV2BillingMeterApi"
    ],
    "v2_license_fee": [
      "OpenapiSearchMerchantResourcesV2LicenseFeeApi"
    ],
    "v2_licensed_item": [
      "OpenapiSearchMerchantResourcesV2LicensedItemApi"
    ],
    "v2_metered_item": [
      "OpenapiSearchMerchantResourcesV2MeteredItemApi"
    ],
    "v2_outbound_payment": [
      "OpenapiSearchMerchantResourcesV2OutboundPaymentApi"
    ],
    "v2_pricing_plan": [
      "OpenapiSearchMerchantResourcesV2PricingPlanApi"
    ],
    "v2_rate_card": [
      "OpenapiSearchMerchantResourcesV2RateCardApi"
    ],
    "v2_recipient": [
      "OpenapiSearchMerchantResourcesV2RecipientApi"
    ],
    "v2_transaction": [
      "OpenapiSearchMerchantResourcesV2TransactionApi"
    ]
  },
  "OpenapiAccountDebitAccount_or_OpenapiAlipayAccount_or_OpenapiBankAccount_or_OpenapiBitcoinReceiver_or_OpenapiCard_or_OpenapiLimitedAccount_or_OpenapiSource": {
    "account": [
      "OpenapiAccountDebitAccount",
      "OpenapiLimitedAccount"
    ],
    "alipay_account": [
      "OpenapiAlipayAccount"
    ],
    "bank_account": [
      "OpenapiBankAccount"
    ],
    "bitcoin_receiver": [
      "OpenapiBitcoinReceiver"
    ],
    "card": [
      "OpenapiCard"
    ],
    "source": [
      "OpenapiSource"
    ]
  },
  "OpenapiAccountDebitAccount_or_OpenapiAlipayAccount_or_OpenapiBankAccount_or_OpenapiBitcoinReceiver_or_OpenapiCard_or_OpenapiPaymentMethod_or_OpenapiSource": {
    "account": [
      "OpenapiAccountDebitAccount"
    ],
    "alipay_account": [
      "OpenapiAlipayAccount"
    ],
    "bank_account": [
      "OpenapiBankAccount"
    ],
    "bitcoin_receiver": [
      "OpenapiBitcoinReceiver"
    ],
    "card": [
      "OpenapiCard"
    ],
    "payment_method": [
      "OpenapiPaymentMethod"
    ],
    "source": [
      "OpenapiSource"
    ]
  },
  "OpenapiAccount_or_OpenapiBankAccount_or_OpenapiCard": {
    "account": [
      "OpenapiAccount"
    ],
    "bank_account": [
      "OpenapiBankAccount"
    ],
    "card": [
      "OpenapiCard"
    ]
  },
  "OpenapiAlipayAccount_or_OpenapiAlipayDeletedAccount_or_OpenapiBankAccount_or_OpenapiBitcoinDeletedReceiver_or_OpenapiBitcoinReceiver_or_OpenapiCard_or_OpenapiDeletedBankAccount_or_OpenapiDeletedCard_or_OpenapiSource": {
    "alipay_account": [
      "OpenapiAlipayAccount",
      "OpenapiAlipayDeletedAccount"
    ],
    "bank_account": [
      "OpenapiBankAccount",
      "OpenapiDeletedBankAccount"
    ],
    "bitcoin_receiver": [
      "OpenapiBitcoinReceiver",
      "OpenapiBitcoinDeletedReceiver"
    ],
    "card": [
      "OpenapiCard",
      "OpenapiDeletedCard"
    ],
    "source": [
      "OpenapiSource"
    ]
  },
  "OpenapiAlipayAccount_or_OpenapiBankAccount_or_OpenapiBitcoinReceiver_or_OpenapiCard_or_OpenapiSource": {
    "alipay_account": [
      "OpenapiAlipayAccount"
    ],
    "bank_account": [
      "OpenapiBankAccount"
    ],
    "bitcoin_receiver": [
      "OpenapiBitcoinReceiver"
    ],
    "card": [
      "OpenapiCard"
    ],
    "source": [
      "OpenapiSource"
    ]
  },
  "OpenapiApplication_or_OpenapiDeletedApplication": {
    "application": [
      "OpenapiApplication",
      "OpenapiDeletedApplication"
    ]
  },
  "OpenapiBackwardsCompatiblePlatformEarning_or_OpenapiBalanceTransferResourceBalanceTransfer_or_OpenapiBitcoinTransaction_or_OpenapiCapitalCashAdvancePaydown_or_OpenapiCapitalCashAdvancePaydownReversal_or_OpenapiCapitalCashAdvancePayout_or_OpenapiCapitalCashAdvancePayoutReversal_or_OpenapiCapitalConnectFinancingTransaction_or_OpenapiCapitalCoreCrossMerchantPaydown_or_OpenapiCapitalCoreCrossMerchantWithholding_or_OpenapiCapitalFlexLoanMinRepaymentCollectionAttempt_or_OpenapiCapitalFlexLoanMinRepaymentCollectionFailure_or_OpenapiCapitalFlexLoanPaydown_or_OpenapiCapitalFlexLoanPaydownReversal_or_OpenapiCapitalFlexLoanPayout_or_OpenapiCapitalFlexLoanPayoutReversal_or_OpenapiCapitalPendingPaydown_or_OpenapiCharge_or_OpenapiChargeWithCharge_or_OpenapiChargeWithPayment_or_OpenapiConnectCollectionTransfer_or_OpenapiCustomerCashBalanceTransaction_or_OpenapiDispute_or_OpenapiDisputeWithDispute_or_OpenapiDisputeWithPaymentDispute_or_OpenapiFeeRefund_or_OpenapiFeesReferralReferralFeeAssessment_or_OpenapiFinancialPartnerDispute_or_OpenapiFinancialPartnerPaymentAuthorization_or_OpenapiFinancialPartnerRefundAuthorization_or_OpenapiIssuingAuthorization_or_OpenapiIssuingCreditRepaymentRepayment_or_OpenapiIssuingDispute_or_OpenapiIssuingFraudLiabilityDebit_or_OpenapiIssuingPlatformHold_or_OpenapiIssuingTransaction_or_OpenapiMerchantBalancesV2ShimResourcesOutboundPaymentExpandedOutboundPayment_or_OpenapiMerchantBalancesV2ShimResourcesOutboundTransferExpandedOutboundTransfer_or_OpenapiPayout_or_OpenapiPlatformFee_or_OpenapiRefund_or_OpenapiRefundWithPaymentRefund_or_OpenapiRefundWithRefund_or_OpenapiReserveTransaction_or_OpenapiReservesReserveHoldsResourcesReserveHold_or_OpenapiReservesReserveReleasesResourcesReserveRelease_or_OpenapiTaxDeductedAtSource_or_OpenapiTopup_or_OpenapiTransfer_or_OpenapiTransferRecipientTransfer_or_OpenapiTransferReversal": {
    "application_fee": [
      "OpenapiBackwardsCompatiblePlatformEarning",
      "OpenapiPlatformFee"
    ],
    "balance_transfer": [
      "OpenapiBalanceTransferResourceBalanceTransfer"
    ],
    "bitcoin_transaction": [
      "OpenapiBitcoinTransaction"
    ],
    "capital.cross_merchant_paydown": [
      "OpenapiCapitalCoreCrossMerchantPaydown"
    ],
    "capital.cross_merchant_withholding": [
      "OpenapiCapitalCoreCrossMerchantWithholding"
    ],
    "capital.financing_transaction": [
      "OpenapiCapitalConnectFinancingTransaction"
    ],
    "cash_advance_paydown": [
      "OpenapiCapitalCashAdvancePaydown"
    ],
    "cash_advance_paydown_reversal": [
      "OpenapiCapitalCashAdvancePaydownReversal"
    ],
    "cash_advance_payout": [
      "OpenapiCapitalCashAdvancePayout"
    ],
    "cash_advance_payout_reversal": [
      "OpenapiCapitalCashAdvancePayoutReversal"
    ],
    "charge": [
      "OpenapiCharge",
      "OpenapiChargeWithCharge",
      "OpenapiChargeWithPayment"
    ],
    "connect_collection_transfer": [
      "OpenapiConnectCollectionTransfer"
    ],
    "customer_cash_balance_transaction": [
      "OpenapiCustomerCashBalanceTransaction"
    ],
    "dispute": [
      "OpenapiDispute",
      "OpenapiDisputeWithDispute",
      "OpenapiDisputeWithPaymentDispute"
    ],
    "expanded_v2.money_management.outbound_payment": [
      "OpenapiMerchantBalancesV2ShimResourcesOutboundPaymentExpandedOutboundPayment"
    ],
    "expanded_v2.money_management.outbound_transfer": [
      "OpenapiMerchantBalancesV2ShimResourcesOutboundTransferExpandedOutboundTransfer"
    ],
    "fee_refund": [
      "OpenapiFeeRefund"
    ],
    "financial_partner.dispute": [
      "OpenapiFinancialPartnerDispute"
    ],
    "financial_partner.payment_authorization": [
      "OpenapiFinancialPartnerPaymentAuthorization"
    ],
    "financial_partner.refund_authorization": [
      "OpenapiFinancialPartnerRefundAuthorization"
    ],
    "flex_loan_min_repayment_collection_attempt": [
      "OpenapiCapitalFlexLoanMinRepaymentCollectionAttempt"
    ],
    "flex_loan_min_repayment_collection_failure": [
      "OpenapiCapitalFlexLoanMinRepaymentCollectionFailure"
    ],
    "flex_loan_paydown": [
      "OpenapiCapitalFlexLoanPaydown"
    ],
    "flex_loan_paydown_reversal": [
      "OpenapiCapitalFlexLoanPaydownReversal"
    ],
    "flex_loan_payout": [
      "OpenapiCapitalFlexLoanPayout"
    ],
    "flex_loan_payout_reversal": [
      "OpenapiCapitalFlexLoanPayoutReversal"
    ],
    "issuing.authorization": [
      "OpenapiIssuingAuthorization"
    ],
    "issuing.credit_repayment": [
      "OpenapiIssuingCreditRepaymentRepayment"
    ],
    "issuing.dispute": [
      "OpenapiIssuingDispute"
    ],
    "issuing.fraud_liability_debit": [
      "OpenapiIssuingFraudLiabilityDebit"
    ],
    "issuing.platform_hold": [
      "OpenapiIssuingPlatformHold"
    ],
    "issuing.transaction": [
      "OpenapiIssuingTransaction"
    ],
    "payout": [
      "OpenapiPayout"
    ],
    "pending_paydown": [
      "OpenapiCapitalPendingPaydown"
    ],
    "recipient_transfer": [
      "OpenapiTransferRecipientTransfer"
    ],
    "referral_fee.assessment": [
      "OpenapiFeesReferralReferralFeeAssessment"
    ],
    "refund": [
      "OpenapiRefund",
      "OpenapiRefundWithPaymentRefund",
      "OpenapiRefundWithRefund"
    ],
    "reserve.hold": [
      "OpenapiReservesReserveHoldsResourcesReserveHold"
    ],
    "reserve.release": [
      "OpenapiReservesReserveReleasesResourcesReserveRelease"
    ],
    "reserve_transaction": [
      "OpenapiReserveTransaction"
    ],
    "tax_deducted_at_source": [
      "OpenapiTaxDeductedAtSource"
    ],
    "topup": [
      "OpenapiTopup"
    ],
    "transfer": [
      "OpenapiTransfer"
    ],
    "transfer_reversal": [
      "OpenapiTransferReversal"
    ]
  },
  "OpenapiBackwardsCompatiblePlatformEarning_or_OpenapiPlatformFee": {
    "application_fee": [
      "OpenapiBackwardsCompatiblePlatformEarning",
      "OpenapiPlatformFee"
    ]
  },
  "OpenapiBankAccount_or_OpenapiCard_or_OpenapiDeletedBankAccount_or_OpenapiDeletedCard_or_OpenapiSource": {
    "bank_account": [
      "OpenapiBankAccount",
      "OpenapiDeletedBankAccount"
    ],
    "card": [
      "OpenapiCard",
      "OpenapiDeletedCard"
    ],
    "source": [
      "OpenapiSource"
    ]
  },
  "OpenapiBankAccount_or_OpenapiCard_or_OpenapiSource": {
    "bank_account": [
      "OpenapiBankAccount"
    ],
    "card": [
      "OpenapiCard"
    ],
    "source": [
      "OpenapiSource"
    ]
  },
  "OpenapiBankConnectionsResourceInternalPaymentAccountBankAccount_or_OpenapiBankConnectionsResourceInternalPaymentDetailsPaymentAccount_or_OpenapiBankConnectionsResourceLinkedAccount": {
    "financial_connections.account": [
      "OpenapiBankConnectionsResourceLinkedAccount"
    ],
    "financial_connections.bank_account": [
      "OpenapiBankConnectionsResourceInternalPaymentAccountBankAccount"
    ],
    "financial_connections.payment_details": [
      "OpenapiBankConnectionsResourceInternalPaymentDetailsPaymentAccount"
    ]
  },
  "OpenapiCapitalAttestationDetailsGroupStubAttestationDetails_or_OpenapiCapitalAttestationDetailsGroupYouLendPersonalGuaranteeDetails": {
    "capital.attestation_details_stub": [
      "OpenapiCapitalAttestationDetailsGroupStubAttestationDetails"
    ],
    "capital.attestation_details_you_lend_personal_guarantee": [
      "OpenapiCapitalAttestationDetailsGroupYouLendPersonalGuaranteeDetails"
    ]
  },
  "OpenapiCapitalCashAdvancePaydown_or_OpenapiCapitalPendingPaydown": {
    "cash_advance_paydown": [
      "OpenapiCapitalCashAdvancePaydown"
    ],
    "pending_paydown": [
      "OpenapiCapitalPendingPaydown"
    ]
  },
  "OpenapiCapitalFlexLoanPaydown_or_OpenapiCapitalPendingPaydown": {
    "flex_loan_paydown": [
      "OpenapiCapitalFlexLoanPaydown"
    ],
    "pending_paydown": [
      "OpenapiCapitalPendingPaydown"
    ]
  },
  "OpenapiCharge_or_OpenapiChargeWithCharge_or_OpenapiChargeWithPayment_or_OpenapiTransfer": {
    "charge": [
      "OpenapiCharge",
      "OpenapiChargeWithCharge",
      "OpenapiChargeWithPayment"
    ],
    "transfer": [
      "OpenapiTransfer"
    ]
  },
  "OpenapiCharge_or_OpenapiPlatformFee_or_OpenapiTransferReversal": {
    "application_fee": [
      "OpenapiPlatformFee"
    ],
    "charge": [
      "OpenapiCharge"
    ],
    "transfer_reversal": [
      "OpenapiTransferReversal"
    ]
  },
  "OpenapiCoupon_or_OpenapiDeletedCoupon": {
    "coupon": [
      "OpenapiCoupon",
      "OpenapiDeletedCoupon"
    ]
  },
  "OpenapiCryptocurrencyBlockchainAddressResourceDeletedExternalAccountBlockchainAddress_or_OpenapiCryptocurrencyBlockchainAddressResourceExternalAccountBlockchainAddress_or_OpenapiDeletedExternalAccountBankAccount_or_OpenapiDeletedExternalAccountCard_or_OpenapiExternalAccountBankAccount_or_OpenapiExternalAccountCard_or_OpenapiExternalAccountFinancialAccountBalance": {
    "bank_account": [
      "OpenapiExternalAccountBankAccount",
      "OpenapiDeletedExternalAccountBankAccount"
    ],
    "blockchain_address": [
      "OpenapiCryptocurrencyBlockchainAddressResourceExternalAccountBlockchainAddress",
      "OpenapiCryptocurrencyBlockchainAddressResourceDeletedExternalAccountBlockchainAddress"
    ],
    "card": [
      "OpenapiExternalAccountCard",
      "OpenapiDeletedExternalAccountCard"
    ],
    "financial_account_balance": [
      "OpenapiExternalAccountFinancialAccountBalance"
    ]
  },
  "OpenapiCryptocurrencyBlockchainAddressResourceDeletedExternalAccountBlockchainAddress_or_OpenapiDeletedExternalAccountBankAccount_or_OpenapiDeletedExternalAccountCard": {
    "bank_account": [
      "OpenapiDeletedExternalAccountBankAccount"
    ],
    "blockchain_address": [
      "OpenapiCryptocurrencyBlockchainAddressResourceDeletedExternalAccountBlockchainAddress"
    ],
    "card": [
      "OpenapiDeletedExternalAccountCard"
    ]
  },
  "OpenapiCryptocurrencyBlockchainAddressResourceExternalAccountBlockchainAddress_or_OpenapiExternalAccountBankAccount_or_OpenapiExternalAccountCard_or_OpenapiExternalAccountFinancialAccountBalance": {
    "bank_account": [
      "OpenapiExternalAccountBankAccount"
    ],
    "blockchain_address": [
      "OpenapiCryptocurrencyBlockchainAddressResourceExternalAccountBlockchainAddress"
    ],
    "card": [
      "OpenapiExternalAccountCard"
    ],
    "financial_account_balance": [
      "OpenapiExternalAccountFinancialAccountBalance"
    ]
  },
  "OpenapiCustomer_or_OpenapiDeletedCustomer": {
    "customer": [
      "OpenapiCustomer",
      "OpenapiDeletedCustomer"
    ]
  },
  "OpenapiDeletedDiscount_or_OpenapiDiscount": {
    "discount": [
      "OpenapiDiscount",
      "OpenapiDeletedDiscount"
    ]
  },
  "OpenapiDeletedInvoice_or_OpenapiInvoice": {
    "invoice": [
      "OpenapiInvoice",
      "OpenapiDeletedInvoice"
    ]
  },
  "OpenapiDeletedPlan_or_OpenapiPlan": {
    "plan": [
      "OpenapiPlan",
      "OpenapiDeletedPlan"
    ]
  },
  "OpenapiDeletedPrice_or_OpenapiPrice": {
    "price": [
      "OpenapiPrice",
      "OpenapiDeletedPrice"
    ]
  },
  "OpenapiDeletedProduct_or_OpenapiProduct": {
    "product": [
      "OpenapiProduct",
      "OpenapiDeletedProduct"
    ]
  },
  "OpenapiDeletedTaxId_or_OpenapiTaxId": {
    "tax_id": [
      "OpenapiTaxId",
      "OpenapiDeletedTaxId"
    ]
  },
  "OpenapiDeletedUser_or_OpenapiUser": {
    "user": [
      "OpenapiUser",
      "OpenapiDeletedUser"
    ]
  },
  "OpenapiDiscount_or_OpenapiSku": {
    "discount": [
      "OpenapiDiscount"
    ],
    "sku": [
      "OpenapiSku"
    ]
  },
  "OpenapiPaymentIntent_or_OpenapiPaymentIntentClient_or_OpenapiPaymentIntentScoped_or_OpenapiPaymentIntentSdk_or_OpenapiPaymentIntentTerminalMerchant": {
    "payment_intent": [
      "OpenapiPaymentIntentTerminalMerchant",
      "OpenapiPaymentIntent",
      "OpenapiPaymentIntentClient",
      "OpenapiPaymentIntentScoped",
      "OpenapiPaymentIntentSdk"
    ]
  },
  "OpenapiPaymentIntent_or_OpenapiPaymentIntentClient_or_OpenapiPaymentIntentTerminalMerchant": {
    "payment_intent": [
      "OpenapiPaymentIntent",
      "OpenapiPaymentIntentClient",
      "OpenapiPaymentIntentTerminalMerchant"
    ]
  },
  "OpenapiPaymentIntent_or_OpenapiPaymentIntentTerminalMerchant": {
    "payment_intent": [
      "OpenapiPaymentIntent",
      "OpenapiPaymentIntentTerminalMerchant"
    ]
  },
  "OpenapiPaymentIntent_or_OpenapiSetupIntent": {
    "payment_intent": [
      "OpenapiPaymentIntent"
    ],
    "setup_intent": [
      "OpenapiSetupIntent"
    ]
  },
  "OpenapiRadarListDeletedListItem_or_OpenapiRadarListListItem": {
    "radar.value_list_item": [
      "OpenapiRadarListListItem",
      "OpenapiRadarListDeletedListItem"
    ]
  },
  "OpenapiRefundWithPaymentRefund_or_OpenapiRefundWithRefund": {
    "refund": [
      "OpenapiRefundWithPaymentRefund",
      "OpenapiRefundWithRefund"
    ]
  },
  "OpenapiRefund_or_OpenapiTerminalMerchantRefund": {
    "refund": [
      "OpenapiRefund",
      "OpenapiTerminalMerchantRefund"
    ]
  },
  "OpenapiRiskCommunicationAccountStatusBooleanCapabilityPause_or_OpenapiRiskCommunicationAccountStatusCapabilityPause_or_OpenapiRiskCommunicationAccountStatusExternalAccountDegraded_or_OpenapiRiskCommunicationAccountStatusPayoutReserve_or_OpenapiRiskCommunicationAccountStatusVolumeCapabilityPause": {
    "risk.account_status.affected_capability.boolean_capability_pause": [
      "OpenapiRiskCommunicationAccountStatusBooleanCapabilityPause"
    ],
    "risk.account_status.affected_capability.capability_pause": [
      "OpenapiRiskCommunicationAccountStatusCapabilityPause"
    ],
    "risk.account_status.affected_capability.external_account_degraded": [
      "OpenapiRiskCommunicationAccountStatusExternalAccountDegraded"
    ],
    "risk.account_status.affected_capability.payout_reserve": [
      "OpenapiRiskCommunicationAccountStatusPayoutReserve"
    ],
    "risk.account_status.affected_capability.volume_capability_pause": [
      "OpenapiRiskCommunicationAccountStatusVolumeCapabilityPause"
    ]
  },
  "OpenapiRiskCommunicationAccountStatusBooleanCapabilityPause_or_OpenapiRiskCommunicationAccountStatusCapabilityPause_or_OpenapiRiskCommunicationAccountStatusVolumeCapabilityPause": {
    "risk.account_status.affected_capability.boolean_capability_pause": [
      "OpenapiRiskCommunicationAccountStatusBooleanCapabilityPause"
    ],
    "risk.account_status.affected_capability.capability_pause": [
      "OpenapiRiskCommunicationAccountStatusCapabilityPause"
    ],
    "risk.account_status.affected_capability.volume_capability_pause": [
      "OpenapiRiskCommunicationAccountStatusVolumeCapabilityPause"
    ]
  },
  "OpenapiRiskCommunicationAccountStatusEmbeddedRemediationChallengeParams_or_OpenapiRiskCommunicationAccountStatusEmbeddedRemediationSettingParams": {
    "risk.account_status.task_remediation_link_params.embedded_remediation_challenge_params": [
      "OpenapiRiskCommunicationAccountStatusEmbeddedRemediationChallengeParams"
    ],
    "risk.account_status.task_remediation_link_params.embedded_remediation_setting_params": [
      "OpenapiRiskCommunicationAccountStatusEmbeddedRemediationSettingParams"
    ]
  },
  "OpenapiRiskDashboardFormsRiskDashboardFormAddBankConnectionQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormAttestationQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormCurrencyInputQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormDateInputQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormDropdownQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormMultiDocumentUploadQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormMultiSelectQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormMultiSelectWithNoneOptionQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormMultiTaggedDocumentUploadQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormPercentInputQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormSingleSelectQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormSingleSelectWithRecommendedOptionQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormTextAreaQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormTextInputQuestion_or_OpenapiRiskDashboardFormsRiskDashboardFormUrlInputQuestion": {
    "risk.general_form.attestation_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormAttestationQuestion"
    ],
    "risk.general_form.bank_connection_prompt_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormAddBankConnectionQuestion"
    ],
    "risk.general_form.currency_input_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormCurrencyInputQuestion"
    ],
    "risk.general_form.date_input_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormDateInputQuestion"
    ],
    "risk.general_form.dropdown_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormDropdownQuestion"
    ],
    "risk.general_form.multi_document_upload_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormMultiDocumentUploadQuestion"
    ],
    "risk.general_form.multi_select_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormMultiSelectQuestion"
    ],
    "risk.general_form.multi_select_with_none_option_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormMultiSelectWithNoneOptionQuestion"
    ],
    "risk.general_form.multi_tagged_document_upload_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormMultiTaggedDocumentUploadQuestion"
    ],
    "risk.general_form.percent_input_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormPercentInputQuestion"
    ],
    "risk.general_form.single_select_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormSingleSelectQuestion"
    ],
    "risk.general_form.single_select_with_recommended_option_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormSingleSelectWithRecommendedOptionQuestion"
    ],
    "risk.general_form.text_area_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormTextAreaQuestion"
    ],
    "risk.general_form.text_input_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormTextInputQuestion"
    ],
    "risk.general_form.url_input_question": [
      "OpenapiRiskDashboardFormsRiskDashboardFormUrlInputQuestion"
    ]
  },
  "OpenapiRiskDashboardFormsRiskDashboardFormGetReadyStartPage_or_OpenapiRiskDashboardFormsRiskDashboardFormMinimalStartPage_or_OpenapiRiskDashboardFormsRiskDashboardFormTaskListStartPage_or_OpenapiRiskDashboardFormsRiskDashboardFormTaxItemListStartPage": {
    "risk.general_form.start_page_get_ready": [
      "OpenapiRiskDashboardFormsRiskDashboardFormGetReadyStartPage"
    ],
    "risk.general_form.start_page_minimal": [
      "OpenapiRiskDashboardFormsRiskDashboardFormMinimalStartPage"
    ],
    "risk.general_form.start_page_task_list": [
      "OpenapiRiskDashboardFormsRiskDashboardFormTaskListStartPage"
    ],
    "tax.general_form.start_page_item_list": [
      "OpenapiRiskDashboardFormsRiskDashboardFormTaxItemListStartPage"
    ]
  },
  "OpenapiRiskDashboardFormsRiskDashboardFormMinimalEndPage_or_OpenapiRiskDashboardFormsRiskDashboardFormNextStepsEndPage_or_OpenapiRiskDashboardFormsRiskDashboardFormTaxTaskListEndPage": {
    "risk.general_form.end_page_minimal": [
      "OpenapiRiskDashboardFormsRiskDashboardFormMinimalEndPage"
    ],
    "risk.general_form.end_page_next_steps": [
      "OpenapiRiskDashboardFormsRiskDashboardFormNextStepsEndPage"
    ],
    "tax.general_form.end_page_task_list": [
      "OpenapiRiskDashboardFormsRiskDashboardFormTaxTaskListEndPage"
    ]
  },
  "OpenapiSetupIntent_or_OpenapiSetupIntentClient_or_OpenapiSetupIntentSdk_or_OpenapiSetupIntentTerminalClient_or_OpenapiSetupIntentTerminalMerchant": {
    "setup_intent": [
      "OpenapiSetupIntent",
      "OpenapiSetupIntentClient",
      "OpenapiSetupIntentSdk",
      "OpenapiSetupIntentTerminalClient",
      "OpenapiSetupIntentTerminalMerchant"
    ]
  },
  "OpenapiSetupIntent_or_OpenapiSetupIntentTerminalClient_or_OpenapiSetupIntentTerminalMerchant": {
    "setup_intent": [
      "OpenapiSetupIntent",
      "OpenapiSetupIntentTerminalMerchant",
      "OpenapiSetupIntentTerminalClient"
    ]
  },
  "OpenapiTaxProductSettingsTaxCodeAssistantAiAssistedTokenList_or_OpenapiTaxProductSettingsTaxCodeAssistantTokenList": {
    "tax_code.ai_assisted_token_list": [
      "OpenapiTaxProductSettingsTaxCodeAssistantAiAssistedTokenList"
    ],
    "tax_code.token_list": [
      "OpenapiTaxProductSettingsTaxCodeAssistantTokenList"
    ]
  },
  "OpenapiTaxReportingResourceTax1099KNumericalData_or_OpenapiTaxReportingResourceTax1099MiscNumericalData_or_OpenapiTaxReportingResourceTax1099NecNumericalData": {
    "tax_reporting.k_numerical_data": [
      "OpenapiTaxReportingResourceTax1099KNumericalData"
    ],
    "tax_reporting.misc_numerical_data": [
      "OpenapiTaxReportingResourceTax1099MiscNumericalData"
    ],
    "tax_reporting.nec_numerical_data": [
      "OpenapiTaxReportingResourceTax1099NecNumericalData"
    ]
  },
  "OpenapiTaxReportingResourceTax1099KNumericalDeltas_or_OpenapiTaxReportingResourceTax1099MiscNumericalDeltas_or_OpenapiTaxReportingResourceTax1099NecNumericalDeltas": {
    "tax_reporting.k_numerical_deltas": [
      "OpenapiTaxReportingResourceTax1099KNumericalDeltas"
    ],
    "tax_reporting.misc_numerical_deltas": [
      "OpenapiTaxReportingResourceTax1099MiscNumericalDeltas"
    ],
    "tax_reporting.nec_numerical_deltas": [
      "OpenapiTaxReportingResourceTax1099NecNumericalDeltas"
    ]
  },
  "OpenapiTerminalConfigurationConfiguration_or_OpenapiTerminalConfigurationDeletedConfiguration": {
    "terminal.configuration": [
      "OpenapiTerminalConfigurationConfiguration",
      "OpenapiTerminalConfigurationDeletedConfiguration"
    ]
  },
  "OpenapiTerminalLocationDeletedLocation_or_OpenapiTerminalLocationLocation": {
    "terminal.location": [
      "OpenapiTerminalLocationLocation",
      "OpenapiTerminalLocationDeletedLocation"
    ]
  },
  "OpenapiTerminalReaderDeletedReader_or_OpenapiTerminalReaderReader": {
    "terminal.reader": [
      "OpenapiTerminalReaderReader",
      "OpenapiTerminalReaderDeletedReader"
    ]
  },
  "OpenapiTerminalZoneDeletedZone_or_OpenapiTerminalZoneZone": {
    "terminal.zone": [
      "OpenapiTerminalZoneZone",
      "OpenapiTerminalZoneDeletedZone"
    ]
  }
}